export default "<h3>Devex Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"